module.exports = __webpack_public_path__ + "static/fonts/ae_AlMothnna_bold.1824141.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/ae_AlMothnna_bold.ttf
// module id = BNB/
// module chunks = 1